import { createContext } from "react";

// Context d'ouverture ou non des inscriptions.
// Par défaut, les inscriptions sont fermées
export const OpenContext = createContext(false);
